import { Link } from "react-router-dom";
import styled from "styled-components";

const FooterText = styled.p`
  margin: 8px 0 0;
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  line-height: 140%;
  color: #667085;
  text-align: center;
`;

const FooterLink = styled(Link)`
  color: #01ab7d;
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: #007656;
  }
`;

export default function AuthLoginFooter() {
  return (
    <FooterText>
      Lembrou sua senha? <FooterLink to="/auth/login">Faça o login</FooterLink>
    </FooterText>
  );
}
